import buttonSettings from '_containers/Theme/corporate/button';
import colors from '_containers/Theme/corporate/colors';
import { fixedBody12, fixedTitle16 } from '_utils/styles';

/** The CTA's corner radius, straight off the design file. */
const CTA_RADIUS = 16;

export default {
  appIcon: {
    // The tile artwork carries its own gradient and corner radius.
    background: colors.all.transparent,
  },
  /**
   * The pill is taken from corporate on every site, colour and shape both.
   * In The Black's palette has no CPA yellow in it, its `secondaryDark` button
   * - the variant the design's pill matches - is an empty placeholder, and its
   * `slim` button is a 4px rectangle rather than a pill. Borrowing either from
   * the site's own buttons gives a different banner on In The Black, and this
   * banner is meant to look the same wherever it appears.
   */
  cta: {
    colors: {
      background: colors.all.brandPrimary2,
      backgroundHover: colors.all.brandPrimary2Dark,
      border: colors.all.brandPrimary2,
      borderFocus: colors.all.interactive200,
      borderHoverWidth: 0,
      borderWidth: 0,
      color: colors.all.brandPrimary3,
      colorHover: colors.all.brandPrimary3,
    },
    /*
     * The slim button is the design's pill in every way but its corners: the
     * design file gives the CTA a 16px radius, corporate's slim button is
     * fully round and In The Black's is a 4px rectangle. At the pill's 32px
     * height 16px reads as fully round anyway, but it is what the file says.
     */
    size: {
      ...buttonSettings.slim,
      borderRadius: {
        topLeft: CTA_RADIUS,
        topRight: CTA_RADIUS,
        bottomLeft: CTA_RADIUS,
        bottomRight: CTA_RADIUS,
      },
    },
  },
  description: {
    color: colors.all.darkText,
    text: fixedBody12,
  },
  title: {
    color: colors.all.neutralWhite,
    text: fixedTitle16,
  },
  trigger: {
    pathFillColor: colors.all.neutralWhite,
  },
  wrapper: {
    // TODO: swap for the real background token once it comes out of the design file.
    background: 'linear-gradient(90deg, #0D114F 0%, #0230FF 100%)',
    color: colors.all.neutralWhite,
  },
};
